import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Button } from "antd";
import BasicLayout from "../../../common/BasicLayout";
import styled from "styled-components";

const CustomButton = styled(Button)`
  && {
    margin-top: 25px;
    color: #fff;
    border: none;
    background-color: ${props => props.bgcolor};
    display: block;
    width: 100%;
    white-space: normal;
    height: 50px;
    border-radius: 15px;

    :hover,
    :active,
    :hover {
      background-color: ${props => props.bgcolor};
    }

    @media (min-width: 768px) {
      margin: 25px auto;
      width: 85%;
    }

    @media (min-width: 992px) {
      margin: 25px auto;
      width: 65%;
    }
  }
`;

export default class FedGrantContractSalaryMain extends Component {
  render() {
    return (
      <BasicLayout>
        <h1 style={{ textAlign: "center", margin: "25px 0" }}>
          Fedaral Grant/Contract Salary Reporting
        </h1>
        <div style={{ textAlign: "center", margin: "25px 50px" }}>
          <p>
            HCDE has developed a system of controls to comply with federal
            guidelines under Title 2 CFR 200, Subpart E, Cost Principles. The
            employee will start by submitting the Time &amp; Effort
            Certification Form and have it approved through 2 levels: The{" "}
            <strong>(1) Supervisor</strong>, then the{" "}
            <strong>(2) Director or Compliance Officer</strong>.
          </p>
          <p>
            If the form is disapproved or rejected for any reason, the employee
            must make the appropriate changes and resubmit the form which will
            then go back through the same approval process. At the end, the
            employee will be able to download a complete file of the form,
            approvals and attachments for the files.
          </p>
          <CustomButton bgcolor="#0984e3" size="large" type="primary">
            <Link to="/time-effort-certification-form">
              Time &amp; Effort Certification Form
            </Link>
          </CustomButton>
          <CustomButton bgcolor="#00b894" size="large" type="primary">
            <Link to="/track-form">Track your form</Link>
          </CustomButton>
        </div>
      </BasicLayout>
    );
  }
}
